import { CSSProperties } from 'react';
import { useLingui } from '@lingui/react/macro';

import { InputSelect } from '@/design_system/InputSelect/InputSelect';
import { useCompanies } from '@/models/company';

export const InvoiceLineDestinationSelect = ({
  setPage,
  invoiceLineDestination,
  setInvoiceLineDestination,
  style,
}: {
  setPage?: (page: number) => void;
  invoiceLineDestination: string;
  setInvoiceLineDestination: (destination: string) => void;
  style?: CSSProperties;
}) => {
  const { t } = useLingui();

  const { data, isFetching } = useCompanies({
    limit: 100,
    traits: ['aftersales', 'store'],
  });

  const options = data?.companies ?? [];

  const selectedOption = options.find((option) => option.id === invoiceLineDestination) ?? null;

  if (!options.length) {
    return null;
  }

  return (
    <InputSelect
      variant="select"
      placeholder={t({
        id: 'accounting.invoice-lines.recipient.placeholder',
        message: 'Recipient: All',
      })}
      aria-label={t({
        id: 'accounting.invoice-lines.recipient.label',
        message: 'Recipient',
      })}
      value={selectedOption}
      isClearable
      options={options}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onChange={(option, action) => {
        if (action.action === 'clear') {
          setInvoiceLineDestination('');
        } else if (option) {
          setInvoiceLineDestination(option.id);
        }

        setPage?.(1);
      }}
      isLoading={isFetching}
      style={style}
    />
  );
};
